import { createSelector } from '@reduxjs/toolkit';

import { createCustomSelector } from '@/utils/functions';
import { sectionTypes } from '@/utils/sectionEnums';

export const selectMenuRequesting = (state) => state.menu.requesting;
export const selectMenuError = (state) => state.menu.error;

export const selectMenuId = (state) => state.menu.id;
export const selectMenuUID = (state) => state.menu.uid;
export const selectMenuSID = (state) => state.menu.sid;
export const selectMenuIsAdded = (state) => state.menu.isAdded;
export const selectMenuIsActive = (state) => state.menu.isActive;

export const selectMenuView = (state) => state.menu.view;
export const selectMenuItems = (state) => state.menu.items;

export const selectMenuBlockContent = createSelector(
  (state) => state.menu,
  (menu) => ({
    heading: menu.heading,
    items: menu.items,
    categories: menu.categories,
    menuType: menu.menuType,
    pdfUrl: menu.pdfUrl,
    view: menu.view,
    layout: menu.layout,
  }),
);

export const selectMenuBlockDesign = createSelector(
  (state) => state.menu,
  (menu) => ({
    containerDesign: menu.containerDesign,
    itemDesign: menu.itemDesign,
    buttonDesign: menu.buttonDesign,
    view: menu.designView,
    layout: menu.designLayout,
    itemTextAlign: menu.itemTextAlign,
    itemTitleSize: menu.itemTitleSize,
    itemLayout: menu.itemLayout,
    itemFields: menu.itemFields,
    itemColumns: menu.itemColumns,
  }),
);

export const selectMenuHeading = (state) => state.menu.heading;
export const selectMenuMenuType = (state) => state.menu.menuType;
export const selectMenuPdfUrl = (state) => state.menu.pdfUrl;
export const selectMenuLayout = (state) => state.menu.layout;
export const selectMenuCategories = (state) => state.menu.categories;

export const selectMenuContainerDesign = (state) => state.menu.containerDesign;
export const selectMenuItemDesign = (state) => state.menu.itemDesign;
export const selectMenuButtonDesign = (state) => state.menu.buttonDesign;

export const selectMenuDesignView = (state) => state.menu.designView;
export const selectMenuDesignLayout = (state) => state.menu.designLayout;

export const selectHeadingObj = createCustomSelector(sectionTypes.menu.type);
